import { render, staticRenderFns } from "./iconDiscussion.vue?vue&type=template&id=69cd64c6"
import script from "./iconDiscussion.vue?vue&type=script&lang=js"
export * from "./iconDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports